import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid var(--color-grayscale-trout);
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-grayscale-trout);
  }
`;
